import { BaseIconButton, type BaseIconButtonProps } from './BaseIconButton';

type Props = Omit<BaseIconButtonProps, 'variant'>;

export const TertiaryIconButton = (props: Props) => {
  return <BaseIconButton variant="tertiary" {...props} />;
};
